import type { Middleware } from '@reduxjs/toolkit';

import { logError } from '../../utils/logging';
import { analyticsClient } from './config';
import { actionTransforms } from './constants';

const analyticsMiddleware: Middleware = store => next => action => {
  const state = store.getState();
  const actionTransform = actionTransforms[action.type];
  if (!actionTransform) return next(action);

  try {
    const event = actionTransform(action.payload, state);
    analyticsClient.track(event.name, event.properties);
  } catch (error) {
    logError(error as any, { location: 'Analytics action transform' });
  }
  return next(action);
};

export { analyticsMiddleware };
